module.exports = __webpack_public_path__ + "img/speakers-duotone.0f2d0a61.svg";